/**
 * Landing page for `ZoomMtg.init({leaveUrl})`.
 *
 * When a user clicks "Leave" inside the Zoom client chrome, the SDK navigates
 * the iframe to this URL. There's no SDK event we can listen to for that
 * action, so we use this page as the deterministic teardown signal: it posts
 * `{state:'ended'}` to the parent on mount.
 */

import React from 'react'

import './ZoomHostPage.scss'

class MeetingEndedPage extends React.Component {
  componentDidMount() {
    document.documentElement.classList.add('zoom-host-shell')
    document.body.classList.add('zoom-host-shell')

    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage(
          {
            type: 'zoom-host:connection-change',
            state: 'ended',
            reason: 'leave-url',
          },
          window.location.origin
        )
      }
    } catch (e) {
      // Best-effort — parent navigation can race.
    }
  }

  componentWillUnmount() {
    document.documentElement.classList.remove('zoom-host-shell')
    document.body.classList.remove('zoom-host-shell')
  }

  render() {
    return (
      <div className='zoom-host__loading'>
        <p>The meeting has ended.</p>
      </div>
    )
  }
}

export default MeetingEndedPage
